var window_host = "https://" + window.location.host ;

$(document).ready(function () {

  /* REDIRECTS FIX */
  /* ############# */
  /*
  const protocol = window.location.protocol; // https:
  const host = window.location.host; // www.babycool.com
  const pathname = window.location.pathname; // /collections/vendors
  const search = window.location.search; // ?q=smallfoot/by,product_in_stock/results,73-96
  const hash = window.location.hash;
  const current=protocol+"//"+host+pathname; // https://www.babycool.com/collections/vendors
  const address=host+pathname; // www.babycool.com/collections/vendors
  const parts = address.split("/");
  const previous=parts[parts.length-2];
  const last=parts[parts.length-1];
  const first=parts[1]


  // RESOLVER ESTE TIPO DE PROBLEMA
  // https://www.babycool.com/collections/vendors?q=smallfoot/by,product_in_stock/results,73-96
  if (last && last=="vendors"){
    var search_parts=search.split("/");
    if (search_parts.length>1){
      location.href=current+search_parts[0]
    }
  }

 
  console.log("FIRST: "+first)
  console.log("PREVIOUS: "+previous)
  console.log("LAST: "+last)

  // RESOLVER ESTE TIPO DE PROBLEMA
  // https://www.babycool.com/shop/results,2581-2640?&viewmode=list?&&ordem=toploja
  if (previous && previous=="shop" && last.indexOf("results,")==0){
    location.href="/collections/all"
  }

  // RESOLVER ESTE TIPO DE PROBLEMA
  // https://www.babycool.com/shop/by,product_sales/results,1351-1500?ordem=toploja
  if (first && first=="shop" && last.indexOf("results,")==0){
    location.href="/collections/all"
  }

  // RESOLVER ESTE TIPO DE PROBLEMA
  // https://www.babycool.com/collections/vendors?q=neogrun?cfm%5B0%5D=0?&ordem=topvendas
  console.log(search.split("?").length)
  
  if (previous && previous=="collections" && last && last=="vendors" && search && search.split("?").length>2){
    var s=search.split("?")
    
    location.href="/collections/vendors?"+s[1]
  }
  */
  /* ############# */



  
  var userAgent = navigator.userAgent; 
  if(userAgent.includes("Firefox")){
     $("a[href*='.pdf']").each(function() {
        var link = $(this).attr('fileName');
        $(this).attr('download', link);
    });
  }
  
  changeStyleSelect();

  $(document).on('click', '.loading_modal .close', function(e) {
    removeLoadingModal();
  });

  if($(".newsletter-success").length > 0 || window.location.href.indexOf("customer_posted=true") > -1){
    showLoadingModal("Obrigada por Subscrever!", "Em breve receberá um e-mail de boas vindas.");
    removeLoadingModal();
  }

  if($(".template-register").length > 0){
    var InputId = "#register_password";
    passwordEyeInteraction(InputId);
  }

  if($(".template-login").length > 0){
    var InputId = "#customer_password";
    passwordEyeInteraction(InputId);
  }

  showLoginBtn();
  $(window).resize(function() {
    showLoginBtn();
  });

  if(!$("body").hasClass("customer_loggin")){
    var existCondition = setInterval(function() {
     if ($('.wishlist-container').length) {
        clearInterval(existCondition);
        alertWishlist();
     }
    }, 100);
  }

  $(document).on('click', '.toggle_btn', function(e) {
    $(this).toggleClass("active");
    $(".product-description").toggleClass("active");
  
    if($(".toggle_btn").hasClass("active")){
      $(".toggle_text").text("Ver menos");
    }
    else{
      $(".toggle_text").text("Ver mais");
    }
  });

 if ($(".template-collection").length > 0) {
    setInterval(function () {
      var isChecked = $(".template-collection .utils-compare-toggle__checkbox").is(':checked');
      var enabledProducts = $(".productitem__compare.productitem__compare--enabled");
      var productWrappers = $(".productitem__compare-wrapper");
  
        enabledProducts.each(function () {
        var $this = $(this);
        $this.css("opacity", isChecked ? "1" : "0");
        $this.css("transition", "opacity 0.5s 100ms");
      });
    
      productWrappers.css("transform", "translateX(0)");
  
    }, 100);
 } else {
    setInterval(function () {
      var enabledProducts = $(".productitem__compare.productitem__compare--enabled");
  
      enabledProducts.each(function () {
        var $this = $(this);
        $this.css("opacity", "1");
        $this.css("transition", "opacity 0.5s 100ms");
      });
  
    }, 100);
 }


 /* $(".wishlist-engine").click(function() {

    /*if ($(".h-wishlist-icon svg").first().css("fill") === "#fec8dd") {
      console.log("The fill color is #fec8dd");
    } else {
      console.log("The fill color is not #fec8dd");
    }
    
   $(".h-wishlist-icon svg").first().css("fill", "#fec8dd");
    
  });*/



  var data_gallery_index = parseInt($(".product-gallery--viewer figure[data-gallery-selected='true']").attr("data-gallery-index")) - 1;
    if(data_gallery_index < 0){
     $(".gallery-navigation-scroll-button.scroll-left").css("color", "grey");
      $(".gallery-navigation-scroll-button.scroll-right").css("color", "inherit");
    }else{
      $(this).css("color", "inherit");
      $(".gallery-navigation-scroll-button.scroll-right").css("color", "inherit");
      $(".product-gallery--viewer figure[data-gallery-selected='true']").attr("data-gallery-selected", "false");
      $(".product-gallery--viewer figure[data-gallery-index='" + data_gallery_index + "']").attr("data-gallery-selected", "true");

      $(".gallery-navigation--scroller .product-gallery--media-thumbnail[data-gallery-selected='true']").attr("data-gallery-selected", "false");
      $(".gallery-navigation--scroller .product-gallery--media-thumbnail[data-gallery-index='" + data_gallery_index + "']").attr("data-gallery-selected", "true");

    }

  $(".gallery-navigation-scroll-button.scroll-left").click(function(e) {
    e.stopPropagation();
    var data_gallery_index = parseInt($(".product-gallery--viewer figure[data-gallery-selected='true']").attr("data-gallery-index")) - 1;
    if(data_gallery_index < 0){
      $(this).css("color", "grey");
      $(".gallery-navigation-scroll-button.scroll-right").css("color", "inherit");
    }else{
      $(this).css("color", "inherit");
      $(".gallery-navigation-scroll-button.scroll-right").css("color", "inherit");
      $(".product-gallery--viewer figure[data-gallery-selected='true']").attr("data-gallery-selected", "false");
      $(".product-gallery--viewer figure[data-gallery-index='" + data_gallery_index + "']").attr("data-gallery-selected", "true");

      $(".gallery-navigation--scroller .product-gallery--media-thumbnail[data-gallery-selected='true']").attr("data-gallery-selected", "false");
      $(".gallery-navigation--scroller .product-gallery--media-thumbnail[data-gallery-index='" + data_gallery_index + "']").attr("data-gallery-selected", "true");

    }

  });

  $(".gallery-navigation-scroll-button.scroll-right").click(function(e) {
    e.stopPropagation();
    var data_gallery_last_index = parseInt($(".product-gallery--viewer figure:not(.product-gallery--video)").last().attr("data-gallery-index"));
    var data_gallery_index = parseInt($(".product-gallery--viewer figure[data-gallery-selected='true']").attr("data-gallery-index")) + 1;
    console.log(data_gallery_index)
    console.log(data_gallery_last_index)
    if(data_gallery_index > data_gallery_last_index){
      $(this).css("color", "grey");
       $(".gallery-navigation-scroll-button.scroll-left").css("color", "inherit");
      
    }else{
      $(this).css("color", "inherit");
      $(".gallery-navigation-scroll-button.scroll-left").css("color", "inherit");
      $(".product-gallery--viewer figure[data-gallery-selected='true']").attr("data-gallery-selected", "false");
      $(".product-gallery--viewer figure[data-gallery-index='" + data_gallery_index + "']").attr("data-gallery-selected", "true");

      $(".gallery-navigation--scroller .product-gallery--media-thumbnail[data-gallery-selected='true']").attr("data-gallery-selected", "false");
      $(".gallery-navigation--scroller .product-gallery--media-thumbnail[data-gallery-index='" + data_gallery_index + "']").attr("data-gallery-selected", "true");
      
    }
  });


});





window.addEventListener('load', function() {
  const slider = document.querySelector('.product-recommendations--container');
  if(slider){
    const leftArrow = document.querySelector('.left-arrow');
    const rightArrow = document.querySelector('.right-arrow');
    const itemWidth = slider.querySelector('li').offsetWidth + 20; 
    const numItemsToSlide = 1;
    let pointerDown = false;
    let startX, scrollLeft;
    let requestId;
  
    let startDragging = function (e) {
      pointerDown = true;
      if (e.type === 'touchstart') {
        startX = e.touches[0].pageX - slider.offsetLeft;
      } else {
        startX = e.pageX - slider.offsetLeft;
      }
      scrollLeft = slider.scrollLeft;
      cancelAnimationFrame(requestId);
    };
  
    let stopDragging = function (event) {
      pointerDown = false;
    };
  
    let handleDragging = function (e) {
      e.preventDefault();
      if (!pointerDown) { return; }
      const x = (e.type === 'touchmove') ? e.touches[0].pageX - slider.offsetLeft : e.pageX - slider.offsetLeft;
      const scroll = x - startX;
      slider.scrollLeft = scrollLeft - scroll;
      requestId = requestAnimationFrame(handleDragging);
    };
  
    let smoothScrollTo = function (targetX) {
      const distance = targetX - slider.scrollLeft;
      const steps = 30; 
      
      let currentStep = 0;
      let stepDistance = distance / steps;
      
      let animateScroll = function() {
        slider.scrollLeft += stepDistance;
        currentStep++;
        
        if (currentStep < steps) {
          requestId = requestAnimationFrame(animateScroll);
        } else {
          slider.scrollLeft = targetX;
        }
      };
      requestId = requestAnimationFrame(animateScroll);
    };
  
    slider.addEventListener('mousedown', startDragging, false);
    slider.addEventListener('touchstart', startDragging, false);
  
    slider.addEventListener('mouseup', stopDragging, false);
    slider.addEventListener('touchend', stopDragging, false);
  
    slider.addEventListener('mousemove', handleDragging, false);
    slider.addEventListener('touchmove', handleDragging, false);
  
    slider.addEventListener('mouseleave', stopDragging, false);

    if(leftArrow){
      leftArrow.addEventListener('click', function() {
        smoothScrollTo(slider.scrollLeft - (itemWidth * numItemsToSlide));
      });
    }
    
    if(rightArrow){
      rightArrow.addEventListener('click', function() {
        smoothScrollTo(slider.scrollLeft + (itemWidth * numItemsToSlide));
      });
    }
    
  }
});

function showLoginBtn() {
 $(".site-header__account-icon").off();
  
 if($(window).width() >= 1024){
  var timer;
    $( ".site-header__account-icon_menu, .site-header__account-icon").on( "mouseover", function() {
      $(".site-header__account-icon_menu").removeClass("d-none");
      clearTimeout(timer); 
    });
  
    $( ".site-header__account-icon_menu" ).on( "mouseout", function() {
      $(".site-header__account-icon_menu").addClass("d-none");
    });
  
    $(".site-header__account-icon").on( "mouseout", function() {
      timer = setTimeout(function() {
         $(".site-header__account-icon_menu").addClass('d-none');
      }, 500); 
    });

 }else{
    $(".site-header__account-icon").click(function() {
      window.location.href = "/account/login";
    });
    $(".site-header__account-icon").css("cursor", "pointer");
 }
}


function changeStyleSelect() {
  $("select.live-search-filter").each(function () {
    var $this = $(this);
    var numberOfOptions = $(this).children("option").length;

    $this.addClass("s-hidden");
    $this.wrap('<div class="select selectMenu"></div>');
    $this.after('<div class="styledSelect live-search-filter-label form-field-select" data-live-search-filter-label></div>');
    var $styledSelect = $this.next("div.styledSelect");
    $styledSelect.text($this.children("option").eq(0).text());

    var $list = $("<ul />", {
      class: "options",
    }).insertAfter($styledSelect);

    for (var i = 0; i < numberOfOptions; i++) {
      $("<li />", {
        text: $this.children("option").eq(i).text(),
        rel: $this.children("option").eq(i).val(),
      }).appendTo($list);
    }

    var $listItems = $list.children("li");

    $(".selectMenu").click(function (e) {
      e.stopPropagation();
      $("div.styledSelect.active").each(function () {
        $(this).removeClass("active").find("ul.options").hide();
      });
      $(this).toggleClass("active").find("ul.options").toggle();
    });

    $listItems.click(function (e) {
      e.stopPropagation();
      $styledSelect.text($(this).text()).removeClass("active");
      $this.val($(this).attr("rel"));
      $list.hide();
    });

    $(document).click(function () {
      $styledSelect.removeClass("active");
      $list.hide();
    });
  });
}

function showLoadingModal(msg, content){
  var modalHTML = "";
  modalHTML += "<div class='loading_modal'>";
  modalHTML += "<div class='modal_align'>";
  modalHTML += "<a class='close'>×</a>";
  modalHTML += '<div class="loading_modal_content" style="text-align:center">';
  modalHTML += '<span class="msg">'+ msg + '</span>';
  if (content != null) {
    modalHTML += '<span>'+ content + '</span>';
  }
  modalHTML += "</div></div></div>";
  $("body").addClass("overflow_hidden").prepend(modalHTML);
  
}
  
function removeLoadingModal() {
  $(".loading_modal").delay(2000).fadeOut();
  $("body").delay(1000).removeClass("overflow_hidden");
}

function passwordEyeInteraction(inputId) {
  const togglePassword = document.querySelector('#togglePassword');
  const password = document.querySelector(inputId);
  togglePassword.addEventListener('click', function (e) {
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
    password.setAttribute('type', type);
    this.classList.toggle('fa-eye-slash');
  });
}

function alertWishlist(){
  var modalHTML = "";
  modalHTML += "<div class='alert_wishlist'>";
  modalHTML += "<div class='alert_wishlist_content'>";
  modalHTML += '<span class="wishlist-message"><i class="fa fa-info-circle" aria-hidden="true"></i> <a href="/account/login"">Inicie sessão</a> ou <a href="/account/register">crie uma conta</a> para guardar a sua lista de favoritos.</span>';
  modalHTML += "</div></div>";
  $(".wishlist-header").append(modalHTML);
}



/* vendor-list-item.liquid */

$(document).ready(function(){
  $(".list_all_vendors h3").each(function(){
    var h3 = $(this);
    var first_letter = $(h3)[0].innerHTML;
    var html = `<div id="`+first_letter+`" class="col-12 col-md-12 div_`+first_letter+` one_vendor">`+$(h3)[0].outerHTML+`</div>`;

    $(".list_all_vendors_2 .list_of_vendors .row").append(html);
    var content = `<div class="content"></div>`;
    $(".one_vendor").append(content)
    
    $(".list_all_vendors .vendor_"+first_letter).each(function(){
      $(".div_"+first_letter+ " .content").append($(this)[0]);
    });
    
  });

  $('a[href^="#"]').on('click', function (event) {
    var href = $(this).attr('href');
    if (href.startsWith("#")) {
      event.preventDefault();
      
      var target = $(document.getElementById(href.substring(1)));
      if (target.length) {
        $('html, body').animate(
          {
            scrollTop: target.offset().top - target.outerHeight(),
          },
          1000
        );
      }
    }
  });

})

